import { CategoryTopSection } from '../components';
import { HotNews } from '@/components/Shared';
import { WrapperTwoLayout } from '@/components/Layouts';
import {
  SmallCategoryLeftSection,
  SmallCategoryRightSection,
} from './components';
import { ICategoryLayout } from '@/interfaces/category';
import { Layout_Page_Tops_Enum } from '@/generated/graphql';

const SmallCategory = ({ data }: ICategoryLayout) => {
  const {
    allPosts,
    children,
    name,
    pathFullSlug,
    relatedCategories,
    id,
    layoutPageTop,
  } = data?.categories[0] || {};
  return (
    <div className="container">
      <div className="my-3 flex flex-col gap-4">
        <CategoryTopSection
          posts={allPosts}
          categories={children}
          name={name || ''}
          slug={pathFullSlug?.fullSlug || ''}
          small
          layoutPageTop={
            layoutPageTop ?? Layout_Page_Tops_Enum.OneLargeFiveSmall
          }
        />
        <HotNews />
        <WrapperTwoLayout
          leftColumn={<SmallCategoryLeftSection id={id} />}
          rightColumn={<SmallCategoryRightSection data={relatedCategories} />}
        />
      </div>
    </div>
  );
};

export default SmallCategory;
